import { DeviceKassaProps, DeviceNetworkProps } from '@/interfaces/models/device';
import DeviceKassa from '@/models/deviceKassa';
import DeviceNetwork from '@/models/deviceNetwork';

export default () => {
  if (Array.isArray(window.axios.defaults.transformResponse)) {
    return window.axios.defaults.transformResponse.concat((devices: any): any => {
      devices.pos = devices.pos.map((device: DeviceKassaProps) => new DeviceKassa(device));
      devices.network = devices.network.map((device: DeviceNetworkProps) => new DeviceNetwork(device));

      return devices;
    });
  }
};
